import { noop } from 'lodash-es';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import AuthCard from '../AuthCard';
import AuthNavLink from '../AuthNavLink';
import ResetPasswordForm, {
  ResetPasswordFormProps,
} from '../ResetPasswordForm';
import {
  RESET_PASSWORD_CARD_TITLE,
  CANCEL_RESET_PASSWORD_BUTTON_TEXT,
} from './constants';

export interface ResetPasswordRequestCardProps
  extends Pick<ResetPasswordFormProps, 'onSubmit' | 'onSuccess'> {}

/**
 * A `Card` than handles resetting a user's password
 */
export const ResetPasswordRequestCard: React.FC<
  ResetPasswordRequestCardProps
> = ({ onSubmit, onSuccess = noop }) => {
  const [resetPasswordToken, setResetPasswordToken] = useState<string>();

  useEffect(() => {
    const queryParams = queryString.parse(window.location.search);
    setResetPasswordToken(queryParams.resetPasswordToken as string);
  }, []);

  return (
    <AuthCard
      header={<AuthCard.Header title={RESET_PASSWORD_CARD_TITLE} />}
      footer={
        <AuthCard.Footer>
          <AuthNavLink
            appearance="link"
            typography="heading"
            level={2}
            to="login"
          >
            {CANCEL_RESET_PASSWORD_BUTTON_TEXT}
          </AuthNavLink>
        </AuthCard.Footer>
      }
    >
      <AuthCard.Contents>
        <ResetPasswordForm
          onSuccess={onSuccess}
          {...{ onSubmit, resetPasswordToken }}
        />
      </AuthCard.Contents>
    </AuthCard>
  );
};

export default ResetPasswordRequestCard;
